import { Filter } from "@/shared/lib/filter/filter";
import { Address } from "@/services/backend/addresses/types/address";
import { backendApi } from "@/services/backend/api";

const branchApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    putBranch: build.mutation<Branch, PutBranchRequest>({
      query: (request) => ({
        url: `branches/branch`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Branch"],
    }),
    branchesBranchShow: build.query<Branch, ShowBranchRequest>({
      query: (request) => ({
        url: `branches/branch`,
        method: "GET",
        params: request,
      }),
      providesTags: (result) =>
        result ? [{ type: "Branch", id: result.id }] : [],
    }),
    listBranch: build.query<List, ListBranchRequest>({
      query: (request) => ({
        url: `branches/branch/list`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: (result) =>
        result
          ? result.branches?.map((p) => ({ type: "Branch", id: p.id }))
          : [{ type: "Branch", id: "LIST" }],
    }),
    deleteBranch: build.mutation<Branch, DeleteBranchRequest>({
      query: (request) => ({
        url: `branches/branch`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["Branch"],
    }),
  }),
});

export const {
  usePutBranchMutation,
  useBranchesBranchShowQuery,
  useListBranchQuery,
  useDeleteBranchMutation,
} = branchApi;

export interface Branch {
  id: string;
  name: string;
  companyId: string;
  address: Address;
  phone: string;
  email: string;
  branchManager: string;
}

export interface List {
  branches: Branch[];
  count: number;
}

export type PutBranchRequest = Branch;

export interface ShowBranchRequest {
  id: string;
}

export interface DeleteBranchRequest {
  id: string;
}

export interface ListBranchRequest {
  id?: Filter<string>;
  company?: Filter<string>;
  name?: Filter<string>;
}
